import { ReactiveComponent } from "../../core/ReactiveComponent.core";
import { ICON } from "../Icons/Icons";
import { usersToSelection } from "../../socket/socketHelper";
import { tourID } from "../../setScene";

const getTourStartModalTemplate = () => `
<div class="tour-start">
  <div class="input-field tour-start__tour-name">
    <div class="input-field__input">
      <div class="input-field__input__prefix">
        ${ICON.GLOBE}
      </div>
      <input
        type="text"
        placeholder="${$trans('start-tour-name-placeholder')}"
        class="tour-start__tour-name__input"
        data-bind="name"
      >
    </div>
  </div>
  <div class="input-field tour-start__visibility">
    <div class="input-field__input">
      <div class="input-field__input__prefix">
        ${ICON.LOCK}
      </div>
      <select
        class="tour-start__visibility__input"
        data-bind="visibility"
      >
        <option value="public" data-lang="start-tour-visibility-public">${$trans('start-tour-visibility-public')}</option>
        <option value="private" data-lang="start-tour-visibility-private">${$trans('start-tour-visibility-private')}</option>
      </select>
      <div class="input-field__input__suffix">
        ${ICON.ARROW_DOWN}
      </div>
    </div>
    <div class="tour-start__visibility__description">
      <span><b data-lang="start-tour-visibility-public">${$trans('start-tour-visibility-public')}</b> - <span data-lang="start-tour-visibility-public-desc">${$trans('start-tour-visibility-public-desc')}</span></span>
      <span><b data-lang="start-tour-visibility-private">${$trans('start-tour-visibility-private')}</b> - <span data-lang="start-tour-visibility-private-desc">${$trans('start-tour-visibility-private-desc')}</span></span>
    </div>
  </div>
  
  <div class="confirm-footer">
    <button class="tour-start__start-btn" data-lang="start-tour-btn">${$trans('start-tour-btn')}</button>
  </div>
</div>
`

const getDefaultName = (socket) => {
  return $trans('start-tour-default-name', { userName: socket.getUserData().userName })
}

export class TourStartForm extends ReactiveComponent {
  /**
   * @param {Model} model
   * @param {Socket} socket
   * @param onConfirm
   */
  constructor({ model, socket, onConfirm = null }) {
    const template = $(getTourStartModalTemplate())

    super(template, {
      name: getDefaultName(socket),
      visibility: 'public',
      invitations: [],
    })

    this.model = model
    this.socket = socket
    this.onConfirm = onConfirm

    this.template = template

    this.bindStates()
    this.addEventListeners()
    if (typeof multiLanguagesController !== 'undefined') {
      multiLanguagesController.renderLanguage()
    }
  }

  bindStates() {
    const checkButton = () => {
      this.template.find('.tour-start__start-btn').toggleClass('tour-start__start-btn--active', !!this.state.name && !!this.state.visibility)
    }

    this.bindState('name', (val) => {
      this.template.find('.tour-start__tour-name').toggleClass('input-field--has-value', !!val)
      this.template.find('.tour-start__tour-name__input').val(val)
      checkButton()
    })

    this.bindState('visibility', (val) => {
      this.template.find('.tour-start__visibility').toggleClass('input-field--has-value', !!val)

      if (val === 'public') {
        this.state.invitations = usersToSelection(this.socket.getOnlineUsers(), this.model);
      } else {
        this.state.invitations = [];
      }
      checkButton()
    })
  }

  addEventListeners() {
    this.template.find('.tour-start__start-btn').on('click', () => {
      if (!this.state.name || !this.state.visibility) {
        return
      }

      this.onConfirm?.({
        ...this.state
      })
    })
  }

  reset() {
    const defaultValues = {
      name: getDefaultName(this.socket),
      visibility: 'public',
      invitations: [],
    }

    Object.keys(defaultValues).forEach(key => {
      this.state[key] = defaultValues[key]
      this.$el.find(`[data-bind="${key}"]`).val(defaultValues[key])
    })
  }
}
